import { useMemo } from 'react'
import { useContestAlert, useFetchUnreadAlertsByUser, useMarkAlertAsRead, useMarkAlertAsResolved } from '@/lib/hooks/alert'
import { useCurrentUser } from '@/features/auth/state/auth'

export function useAlerts() {
  const user = useCurrentUser()
  const { data: alerts = [] } = useFetchUnreadAlertsByUser()
  const { mutate: markAlertAsRead } = useMarkAlertAsRead()
  const { mutate: markAlertAsResolved } = useMarkAlertAsResolved()
  const { mutate: contestAlert } = useContestAlert()
  const shouldBlockNavigation = useMemo(
    () => alerts.some(alert => !alert.read && !alert.resolved && alert.blocksNavigation !== false),
    [alerts]
  )
  const isAlertAcknowledged = useMemo(() => !shouldBlockNavigation, [shouldBlockNavigation])
  const isAdminCeo = user?.typeUser === 'ADMIN' && user?.typeCargo === 'CEO'

  const markAsRead = (id: string) => {
    markAlertAsRead(id)
  }

  const markAsResolved = (id: string, message?: string, targetUserId?: string) => {
    markAlertAsResolved({ id, message, targetUserId })
  }

  const markAsContested = (id: string, message?: string, targetUserId?: string) => {
    contestAlert({ id, message, targetUserId })
  }

  return {
    alerts,
    isAlertAcknowledged,
    shouldBlockNavigation,
    isAdminCeo,
    markAsRead,
    markAsResolved,
    markAsContested
  }
}
